// import nodataimage from '../assets/no-product-found.png'

const NoData = ({ text }) => {
	return (
		<div className="no-data">
			{/* <img src={nodataimage} alt='noData' /> */}
			<p>{text}</p>
		</div>
	);
};
export default NoData;
